import { createAction } from 'typesafe-actions';
import { TpaParamsState } from '../../types/ReduxMisc';

export const setTpaParams = createAction(
  `tpa-params/UPDATE`,
  (tpaParams: TpaParamsState) => tpaParams
)();
